import React from "react";
import TotalAllotmentLeft from "@Route/components/Price/TotalAllotmentLeft";
import FerryTypeBadge from "@Route/components/Ferry/FerryTypeBadge";
import IsMinivanBadge from "@Route/features/statusBadges/features/leftStatusBadges/components/IsMinivanBadge";
import IsMTicketBadge from "@Route/features/statusBadges/features/leftStatusBadges/components/IsMTicketBadge";
import PrivateBusBadge from "@Route/features/statusBadges/features/leftStatusBadges/components/PrivateBusBadge";
import CombinedClassBadge from "@Route/features/statusBadges/features/leftStatusBadges/components/CombinedClassBadge";
import OvernightTravelBadge
    from "@Route/features/statusBadges/features/leftStatusBadges/components/OvernightTravelBadge";
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import SuggestedRouteType from "@Route/types/SuggestedRoute.type";
import useShowLeftStatusBadges
    from "@Route/features/statusBadges/features/leftStatusBadges/hooks/useShowLeftStatusBadges";
import FerryType from "@Route/types/type/Ferry.type";

interface RouteStatusProps {
    route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType | SuggestedRouteType,
}

/**
 * This is a route status label container.
 * It includes all the labels/badges in top left corner of the card
 */
function LeftRouteStatusBadges({route}: RouteStatusProps) {
    const showBadge = useShowLeftStatusBadges(route)
    const {
        allotment: {
            totalAllotmentLeft,
        },
        travelInfo: {
            seatClass,
        },
        type,
    } = route

    return (
        <div className="route-status-badges__left">
            {showBadge.showMTicketBadge && (
                <IsMTicketBadge/>
            )}
            {showBadge.showMinivanBadge && (
                <IsMinivanBadge
                    isPrivate={type.isPrivate}
                />
            )}
            {showBadge.showPrivateBusBadge && (
                <PrivateBusBadge/>
            )}
            {showBadge.showFerryTypeBadge && (
                <FerryTypeBadge
                    ferryVehicle={type.vehicleType as FerryType}
                />
            )}
            {showBadge.showCombinedSeatClassBadge && (
                <CombinedClassBadge
                    seatClass={seatClass}
                />
            )}
            {showBadge.showOvernightTravelBadge && (
                <OvernightTravelBadge/>
            )}
            <TotalAllotmentLeft
                totalAllotmentLeft={totalAllotmentLeft}
            />
        </div>
    )
}

export default LeftRouteStatusBadges